var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg-icon',{attrs:{"name":_vm.name,"height":_vm.height,"width":_vm.width,"original":_vm.original},on:{"click":_vm.onClick}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }